export default "__VITE_ASSET__B25riz0w__"